export const questionnairesBaseQueryKey = 'questionnaires';
export const itemsBaseQueryKey = 'items';
export const usageBaseQueryKey = 'usage';
export const searchBaseQueryKey = 'search';
export const requestsBaseQueryKey = 'requests';
export const questionnaireLibraryModuleKey = 'questionnairesLibraryModule';
export const questionnaireLibraryModulesKey = 'questionnairesLibraryModules';
